import { render } from "./index.vue?vue&type=template&id=44f85bb5"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/templates/services-edit/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44f85bb5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44f85bb5', __exports__)) {
    api.reload('44f85bb5', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=44f85bb5", () => {
    api.rerender('44f85bb5', render)
  })

}


export default __exports__